module.exports = __webpack_public_path__ + "img/edfec20.png";